import { CryptoGuess } from "@/event-core/types";
import { get } from "@/utils/utils";
import BigMath from "@yn/money/math";
import { useEffect, useState } from "react";
import { fetchCryptoGuessPage } from "../api";

interface PastGuessStatus {
    type: "up" | "down";
}

export function usePastThreeGuesses( eventNo: string, mainGuess: CryptoGuess | undefined, expo: number ) {
    const [ pastStatuses, setPastStatuses ] = useState<PastGuessStatus[]>( [] );

    useEffect( () => {
        if ( !eventNo || !mainGuess ) {
            setPastStatuses( [] );
            return;
        }

        const loadPastGuesses = async () => {
            try {
                const mainId = Number( get( mainGuess, "id", 0 ) );
                if ( !mainId ) return;

                const result = await fetchCryptoGuessPage( {
                    eventNo,
                    direction: true, // 获取过去的数据
                    id: mainId,
                    size: 3,
                } );

                const statuses = result.guessList.map( ( guess: CryptoGuess ) => {
                    const openPrice = Number( BigMath.times( get( guess, "openPrice", 0 ), Math.pow( 10, expo ) ) );
                    const closePrice = Number( BigMath.times( get( guess, "closePrice", 0 ), Math.pow( 10, expo ) ) );

                    return {
                        type: closePrice >= openPrice ? "up" : "down",
                    } as PastGuessStatus;
                } );

                setPastStatuses( statuses );
            } catch ( error ) {
                console.error( "Failed to load past guesses:", error );
                setPastStatuses( [] );
            }
        };

        loadPastGuesses();
    }, [ eventNo, mainGuess, expo ] );

    return pastStatuses;
}
